import * as types from './types';
import * as _ from 'lodash';

const INITIAL_STATE = {
  data: null,
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_GRADES:
      if (_.has(action.payload, 'data.Data')) {
        return {
          ...state,
          data: action.payload.data.Data,
        };
      } else {
        return state;
      }

    case types.GET_GRADES_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case types.GRADES_LOAD:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/grades/reducer.js